export * from './header/header.component';
export * from './footer/footer.component';
export * from './loader/loader.component';
export * from './section/section.component';
export * from './consumerinfo/consumerinfo.component';
